import { useQuery } from '@tanstack/react-query';
import { useMediaQuery } from 'react-responsive';

import { getBlogCuration } from '../../../../api/blog';
import SpaceY from '../../../../components/SpaceY';
import UImage from '../../../../components/UImage';
import { handleError, MAX_WIDTH_639PX } from '../../../../utils/common';
import { QueryKeys } from '../../../../utils/common/react-query/query-keys';
import { useAlertModal } from '../../../../utils/hook/hook';
import { useHistoryMethod } from '../../../../utils/hook/useHistoryMethod';
import BlogCuration from '../../../blog/component/BlogCuration';
import IgnoreParentPadding from '../../IgnoreParentPadding';

const arrowRightIcon = `https://uglyus.s3.ap-northeast-2.amazonaws.com/assets/recipe/arrow_right_gray800_24x24.svg`;

const RecipeMainBlogs = () => {
  const { openAlertModal } = useAlertModal();
  const history = useHistoryMethod();
  const isMobile = useMediaQuery({ query: MAX_WIDTH_639PX });

  const { data: curations } = useQuery({
    queryKey: QueryKeys.getBlogCuration,
    queryFn: getBlogCuration,
    meta: {
      onError: (e: unknown) =>
        handleError(openAlertModal, e, '블로그 큐레이션 불러오기'),
    },
  });

  if (!curations) return <></>;

  return (
    <div className="px-16px">
      <button
        onClick={() => history.push('/blogs')}
        className="flex items-center gap-4px"
        type="button"
      >
        <span className="text-22px font-bold">어스로그</span>
        <UImage
          src={arrowRightIcon}
          alt="어스로그"
          width={24}
          height={24}
          className="h-24px w-24px"
        />
      </button>
      <SpaceY height={24} />
      <BlogCuration curations={curations} />
    </div>
  );
};

export default RecipeMainBlogs;
